import { StringParam, useQueryParams, withDefault } from 'use-query-params';

import { IAB_FILTER_KEY } from '@insights_module/constants/contextualAndEntity';
import { IABParamsType } from '@insights_module/types/ContextualAndEntity';

export const useIABParams = () => {
  const [query, setQuery] = useQueryParams({
    [IAB_FILTER_KEY.attractions]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.automotive]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.books_and_literature]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.business_and_finance]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.careers]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.communication]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.crime]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.disasters]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.education]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.entertainment]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.events]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.family_and_relationships]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.fine_art]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.food_and_drink]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.genres]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.healthy_living]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.hobbies_and_interests]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.holidays]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.home_and_garden]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.law]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.maps_and_navigation]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.medical_health]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.music]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.personal_celebrations_and_life_events]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.personal_finance]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.pets]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.politics]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.pop_culture]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.productivity]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.real_estate]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.religion_and_spirituality]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.science]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.shopping]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.sports]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.style_and_fashion]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.technology_and_computing]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.travel]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.video_gaming]: withDefault(StringParam, 'ignore'),
    [IAB_FILTER_KEY.war_and_conflicts]: withDefault(StringParam, 'ignore'),
  });

  const params = Object.keys(query);

  const resetIABParams = () => {
    params.forEach((param) => {
      setQuery(
        {
          [param]: undefined,
        },
        'pushIn'
      );
    });
  };

  const setAllIABParams = (params: IABParamsType) => {
    if (params) {
      Object.entries(params)?.forEach(([key, value]) => {
        setQuery(
          {
            [key]: value,
          } as { [key: string]: string },
          'pushIn'
        );
      });
    }
  };

  return { iabParams: query, setIabParams: setQuery, resetIABParams, setAllIABParams };
};
